<template>
  <div class="wrap">
    <back-button :tag="false" />
    <div class="credential-img">
      <img
        :src="require(`@/assets/img/honor/certificate-${Number(type)}.png`)"
      />
    </div>
    <div class="desc-label">如何获得</div>
    <div class="desc">{{ desc[type - 1] }}</div>
    <div class="progress">
      <van-progress
        color="#f31a5b"
        :percentage="
          Math.ceil((num / target) * 100 > 100 ? 100 : (num / target) * 100)
        "
        pivot-text=""
      />
      <div class="progress-tab">
        <span>0{{ measure }}</span>
        <span>{{ target }}{{ measure }}</span>
      </div>
      <div class="progress-text">
        当前累计{{ measure }}数:<span>{{ num }}</span>
      </div>
    </div>
    <van-button
      class="item-btn"
      color="linear-gradient(to bottom, #9df7d5, #002aa2)"
      round
      @click="openMyCredential()"
      :disabled="num < target"
      >查看我的证书</van-button
    >
    <van-dialog
      v-model="contactDialog"
      class="credential-dialog"
      title=""
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      :lock-scroll="false"
    >
      <div class="dialog_content">
        <img :src="imgSrc" />
      </div>
    </van-dialog>
    <div id="credentialImg">
      <div>
        <img
          class="credential-img"
          :src="require(`@/assets/img/honor/certificate-${Number(type)}.png`)"
        />
        <div class="credential-user" v-if="user">
          {{ user.nickname }}
        </div>
        <div class="credential-info">
          {{ info[type - 1] }}
        </div>
        <div class="credential-sign">颁发此证，以示鼓励！</div>
        <div v-if="date" class="credential-date">
          {{ date }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  data() {
    return {
      desc: [
        "说明：累积竞赛答题（每次答对4题及以上）达到30次",
        "说明：累积竞赛答题满分次数达到10次",
        "说明：累积参与并完成竞赛答题次数达到50次。",
        "说明：累计30天，每天完成至少1次竞赛答题",
        "说明：参与竞赛答题，累计答对50题",
        "说明：参与竞赛答题，累计时长达到120分钟",
      ],
      info: [
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累积竞赛答题（每次答对4题及以上）达到30次，获得【竞赛达人】称号。",
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累积竞赛答题满分次数达到10次，获得【十级学者】称号。",
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累积参与并完成竞赛答题次数达到50次，获得【答题大王】称号。",
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累计30天完成至少每天1次的竞赛答题，获得【知识猎手】称号。",
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累计答对50题，获得【常胜将军】称号。",
        "恭喜您在《2025年山西省公众科学素质网络知识竞赛》网络答题活动中累计竞赛答题时长达到120分钟，获得【学习标兵】称号。",
      ],
      contactDialog: false,
      imgSrc: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    type() {
      return Number(this.$route.query.type);
    },
    num() {
      return Number(this.$route.query.num);
    },
    target() {
      return Number(this.$route.query.target);
    },
    date() {
      return this.$route.query.date;
    },
    measure() {
      if ([1, 2, 3].includes(Number(this.$route.query.type))) {
        return "次";
      } else if (Number(this.$route.query.type) === 4) {
        return "天";
      } else if (Number(this.$route.query.type) === 5) {
        return "题";
      } else {
        return "分钟";
      }
    },
  },
  methods: {
    openMyCredential() {
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.querySelector("#credentialImg"), {
            dpi: 96, // 分辨率
            scale: 1, // 设置缩放
            useCORS: true,
            bgcolor: "#ffffff", // 应该这样写
            logging: false, // 打印日志用的 可以不加默认为false
          })
            .then((canvas) => {
              return new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob));
              });
            })
            .then((blob) => {
              const fr = new FileReader();
              fr.readAsDataURL(blob);
              fr.onload = (e) => {
                this.imgSrc = e.target.result;
              };
              // const url = URL.createObjectURL(blob);
              // this.imgSrc = url;
              this.contactDialog = true;
              this.$toast({
                message: "长按证书图片可保存至手机相册",
                position: "bottom",
              });
            });
        });
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 31px 15px 40px;
  overflow: hidden;
  .credential-img {
    text-align: center;

    img {
      width: 191px;
      height: 289px;
    }
  }

  .desc-label {
    margin-top: 37px;
    font-size: 17px;
    font-weight: 600;
    line-height: 20px;
    color: #222;
    text-align: center;
  }

  .desc {
    padding: 0 40px;
    margin-top: 13px;
    font-size: 12px;
    line-height: 17px;
    color: #999;
    text-align: center;
  }
  .progress {
    position: relative;
    height: 26px;
    padding: 36px 15px 15px;
    margin-top: 30px;
    border: 1px solid #e5e5e5;
    .progress-tab {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      font-size: 14px;
      line-height: 14px;
      color: #999;
    }
    .progress-text {
      position: absolute;
      top: -8px;
      right: 0;
      left: 0;
      width: 140px;
      margin: auto;
      font-size: 12px;
      line-height: 17px;
      color: #222;
      text-align: center;
      background: #fff;
      span {
        margin-left: 5px;
        color: #f31a5b;
      }
    }
  }
  .item-btn {
    width: 100%;
    height: 44px;
    margin-top: 30px;
    font-size: 17px;
    line-height: 17px;
    color: #fff;
  }
  .credential-dialog {
    width: 70%;
    // max-height: 90%;
    overflow: auto;
    border-radius: 0;
    .dialog_content {
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
  #credentialImg {
    position: absolute;
    left: 99999px;
    width: 636px;
    // height: 1122px;
    div {
      position: relative;
      .credential-img {
        width: 100%;
        // height: 100%;
        vertical-align: middle;
      }
      .credential-user {
        position: absolute;
        top: 586px;
        left: 102px;
        font-size: 30px;
        line-height: 42px;
        color: #333;
        border-bottom: 1px solid #ffa402;
      }
      .credential-info {
        position: absolute;
        top: 660px;
        padding: 0 104px;
        font-size: 28px;
        line-height: 48px;
        color: #656565;
      }
      .credential-sign {
        position: absolute;
        top: 880px;
        padding: 0 120px;
        font-size: 24px;
        line-height: 44px;
        color: #656565;
      }
      .credential-date {
        position: absolute;
        top: 920px;
        padding: 0 120px;
        font-size: 24px;
        line-height: 44px;
        color: #656565;
      }
    }
  }
}
</style>
